

















import {getListShops} from '@/services/ShopService';
import {IShop} from '@/models/IShop';
import {Component, Vue, Watch} from 'vue-property-decorator';
import {ModuleShop} from '@/store/modules/ShopModule';
import {ModuleOrganization} from '@/store/modules/OrganizationModule';

@Component({})
export default class ShopSelect extends Vue {

  loading: boolean = true;
  shops: IShop[] = [];
  shop: IShop | null = null;
  organizationCurId: number = 0;

  onChange() {
    ModuleShop.setShopId(this.shop!.id);
  }

  get organizationId() {
    return ModuleOrganization.organizationId;
  }

  @Watch('organizationId', {immediate: true})
  async loadData() {
    try {
      this.loading = true;
      this.organizationCurId = this.organizationId;
      if (this.organizationCurId !== 0) {
        this.shops = await getListShops(this.organizationCurId);
        if (this.shops.length === 0) {
          ModuleShop.setShopId(0);
        } else {
          this.shop = this.shops[0];
          ModuleShop.setShopId(this.shop!.id);
        }
      }
    } finally {
      this.loading = false;
    }
  }
}

